import { render, staticRenderFns } from "./ListShortcutsOutput.vue?vue&type=template&id=f5657950&scoped=true"
import script from "./ListShortcutsOutput.vue?vue&type=script&lang=js"
export * from "./ListShortcutsOutput.vue?vue&type=script&lang=js"
import style0 from "./ListShortcutsOutput.vue?vue&type=style&index=0&id=f5657950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5657950",
  null
  
)

export default component.exports